<template>
    <div class="accordion">
        <div v-show="$store.state.selectedFormType === 'single'" id="delivery-address-parent">
            <delivery-address-form></delivery-address-form>          
        </div>
        <div v-show="$store.state.selectedFormType === 'mass'" id="mass-shipments-parent">
            <mass-shipments-block></mass-shipments-block>
        </div>
    </div>
</template>

<script>
import store from "../../../store";
export default {
    store,
}
</script>
